import axios from "../plugins/axios";

let cancelSource = null;

async function getOrderById(id) {
  if (cancelSource) {
    cancelSource.cancel("previous request canceled");
  }

  cancelSource = axios.CancelToken.source();
  const res = await axios.get(`/qr-app/order/${id}`, {
    cancelToken: cancelSource.token,
  });
  cancelSource = null;
  return res.data;
}

async function getByUniqId(id) {
  if (cancelSource) {
    cancelSource.cancel("previous request canceled");
  }

  cancelSource = axios.CancelToken.source();
  const res = await axios.get(`/qr-app/session/${id}`, {
    cancelToken: cancelSource.token,
  });
  cancelSource = null;
  return res.data;
}

async function update(payload) {
  const res = await axios.put(`/qr-app/session/${payload.id}`, payload.data);
  return res.data;
}

async function moveTable(payload) {
  const res = await axios.put(`/qr-app/session/${payload.id}/move-table`, payload.data);
  return res.data;
}

const sessionService = {
  getByUniqId,
  update,
  moveTable,
  getOrderById,
};

export default sessionService;
